import { IApplicationState } from '../../types/redux';
import { ERequestStatus } from '../../types/requestStatus';

export const selectIsSubmitting = (state: IApplicationState) => {
  return state.pageState.status === ERequestStatus.Loading;
};
